import { render, staticRenderFns } from "./compeitionPointAdjustRecord.vue?vue&type=template&id=7ac6c932&scoped=true"
import script from "./compeitionPointAdjustRecord.vue?vue&type=script&lang=ts"
export * from "./compeitionPointAdjustRecord.vue?vue&type=script&lang=ts"
import style0 from "./compeitionPointAdjustRecord.vue?vue&type=style&index=0&id=7ac6c932&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac6c932",
  null
  
)

export default component.exports